import React from 'react';

const styles = `
  body { 
    font-family: Arial, sans-serif; 
    max-width: 800px; 
    margin: 0 auto; 
    padding: 20px; 
  }
  h1 { 
    color: #ff6b6b; 
    text-align: center; 
    margin-bottom: 5px; 
  }
  .date-range { 
    text-align: center; 
    color: #666; 
    margin-bottom: 20px; 
    font-size: 14px; 
  }
  h2 { 
    color: #3a3a3a; 
    margin-top: 20px; 
    border-bottom: 1px solid #ddd; 
    padding-bottom: 5px; 
  }
  ul { 
    list-style-type: none; 
    padding-left: 10px; 
  }
  li { 
    padding: 5px 0; 
    font-size: 16px; 
    display: flex; 
    justify-content: space-between; 
  }
  .item-quantity { 
    color: #666; 
    font-style: italic; 
    margin-left: 10px; 
  }
  .footer { 
    margin-top: 30px; 
    text-align: center; 
    font-size: 12px; 
    color: #999; 
  }
  .checkbox { 
    display: inline-block; 
    width: 15px; 
    height: 15px; 
    border: 1px solid #aaa; 
    margin-right: 10px; 
    vertical-align: middle; 
  }
`;

const PrintTemplate = ({ dateRangeText, groupedItems }) => {
  const template = `
    <html>
      <head>
        <title>Shopping List - ${dateRangeText}</title>
        <style>${styles}</style>
      </head>
      <body>
        <h1>Shopping List</h1>
        <div class="date-range">For meals: ${dateRangeText}</div>
        ${Object.keys(groupedItems).sort().map(category => `
          <h2>${category.charAt(0).toUpperCase() + category.slice(1)}</h2>
          <ul>
            ${groupedItems[category].map(item => `
              <li>
                <span><span class="checkbox"></span>${item.name}</span>
                <span class="item-quantity">${item.quantity}</span>
              </li>
            `).join('')}
          </ul>
        `).join('')}
        <div class="footer">
          Generated by Jingleez Meal Planner on ${new Date().toLocaleString()}
        </div>
      </body>
    </html>
  `;

  return template;
};

export default PrintTemplate; 